import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Outlet } from 'react-router';

export const GTMWrapper = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.dataLayer?.push({
      event: 'gtm.virtualPageview',
      page_path: pathname,
    });
  }, [pathname]);

  return <Outlet />;
};
